// syntechs — landing page entry point.
// Everything here is progressive enhancement: the page reads and works without
// any of it. The language engine goes first, so every component that shows text
// asks it for the current wording.
import { i18n } from './lib/i18n.js';
import { initLanguageSwitch } from './components/language-switch.js';
import { initHeader } from './components/header.js';
import { initActiveSection, initNavIndicator } from './components/nav.js';
import { initReveals } from './components/reveal.js';
import { initHero } from './components/hero.js';
import { initTypingHeading } from './components/typing-heading.js';
import { initContactForms } from './components/contact-form.js';
import { initFaq } from './components/faq.js';
import { initIntelligenceStrip } from './components/intelligence-strip.js';
import { initLegal } from './components/legal.js';

i18n.init();

initLanguageSwitch();
initHeader();
initActiveSection();
initNavIndicator();
initReveals();
initHero();
initTypingHeading();
initContactForms();
initIntelligenceStrip();
initFaq();
initLegal();
